import UserRoleEnum from '@constants/enums/user/role';

const ProviderRoleEnum = Object.freeze({
    SUPERUSER: UserRoleEnum.SUPERUSER,
    MARKETING: UserRoleEnum.MARKETING,
    CONTENT_APPROVER: UserRoleEnum.CONTENT_APPROVER
});

export default ProviderRoleEnum;
